module.exports = __webpack_public_path__ + "static/media/vf-button-outerwear.422d73ae.svg";